export default {
  title: 'Calculadora de receita da taxa de serviço',
  description: 'Estime o que a taxa de serviço rende por mês. Os valores atualizam-se à medida que escreve.',
  authoritative:
    'A percentagem e a taxa máxima abaixo são as definições que serão aplicadas. O valor médio do pedido e o GMV mensal são apenas estimativas.',
  off_notice:
    'A taxa de serviço está desativada neste restaurante, por isso ainda não gera receita. Guarde uma taxa superior a zero para a ativar.',
  fields: {
    recommended: 'Recomendado: {{value}}',
    aov: {
      label: 'Valor médio do pedido',
      help: 'Tamanho típico do cabaz no seu sistema de encomendas online.',
      placeholder: 'ex. 32,50',
    },
    percentage: {
      label: 'Percentagem da taxa de serviço',
      help: 'Entre {{min}}% e {{max}}%.',
    },
    max_amount: {
      label: 'Taxa máxima por pedido',
      help: '{{max}} é o máximo da plataforma.',
      below_min: 'A taxa máxima deve ser de pelo menos {{min}}.',
    },
    monthly_gmv: {
      label: 'GMV mensal',
      help: 'Valor total de pedidos processado por mês.',
      placeholder: 'ex. 85000',
    },
  },
  outputs: {
    partner_revenue: 'A sua receita mensal estimada',
    approximate: 'Valor aproximado com base nos valores acima — a receita real pode variar.',
    estimate_inputs: 'Com base no valor de pedido e GMV estimados — a receita real pode variar.',
    share: 'Esta é a sua parte de {{share}}% do total da taxa de serviço cobrada.',
    total_collected: 'Total da taxa de serviço cobrada aos clientes no checkout',
    total_collected_note: '— paga pelos clientes, não é receita adicional além do valor acima.',
    effective_rate: 'Taxa efetiva em todos os pedidos',
  },
};
